import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
// import the corresponding css file
import "./Notebook.css";
// import the separated file related to the component
import EC20Notebook from "./EC20Notebook/EC20Notebook";
import SpaCNotebook from "./SpaCNotebook/SpaCNotebook";
import HGTNotebook from "./HorizontalGeneTransfer/HGTNotebook";
import { BacteriaSlider } from "../utils";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";

const Notebook = ({setDisplayNavBar}) => {

  const [loading, setLoading] = useState(true);
  // when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
   let url = window.location.href
   let lastLetter = url.charAt(url.length - 1)
   let secondLastLetter = url.charAt(url.length - 2)
   
   if(secondLastLetter === "_"){
    if(lastLetter === "e"){
      setPage(1)
    } else if(lastLetter === "s"){
        setPage(2)
    }else if(lastLetter==="h"){
      setPage(3)
    }
   
}
      setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds
    window.scrollTo(0, 0);
  }, []);
   useEffect(() => {
    setDisplayNavBar(!loading)
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar])



  const [page, setPage] = useState(1);
  const sliderHandle = (newValue) => {
    setPage(newValue);
  };

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div className="relative">
      {loading ? (<div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>): <script>{document.body.style.overflow = 'auto'}</script>}
        <>
      
        {/* Set the size and crop the image on top of the page */}
        <div className="top-page">
          <h1>Notebook</h1>
        </div>
        {/* divide the section in columns */}
        {/* main content which is a separated file you call and it is displayed on the right of the section above */}
        <BacteriaSlider value={page} onChange={sliderHandle} />
        <main style={{ marginRight: "50px" }}>
          {page === 1 ? (
            <div className="fade-in">
              <EC20Notebook />
            </div>
          ) : page === 2 ? (
            <div className="fade-in1">
              <SpaCNotebook />
            </div>
          ) : page === 3 ?(
            <div className="fade-in2">
              <HGTNotebook />
            </div>
          ): <></>}
        </main>
         </></div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Notebook, "notebook");
